import '~/assets/scss/personal-funds.scss'
import Accordion from '~/js/modules/accordion';

window.addEventListener(`DOMContentLoaded`, () => {

  const accordions = document.querySelectorAll(`.accordion`);
  if (accordions.length) {
    accordions.forEach((accordion) => {
      if (!accordion.classList.contains('main-nav__list') && !accordion.classList.contains('service-request--accordion')) {
        new Accordion(accordion)
      }
    });
  }

  document.querySelectorAll('.js-scroll-button').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector(this.getAttribute('data-href')).scrollIntoView({ block: "center", behavior: "smooth" });
    });
  });
})